import * as zod from 'zod';

/**
 * Discriminated state describing whether this CB is running a
 * non-production dev build, and via which mechanism.
 *
 * - `scp`: services were pushed directly via
 *   `sb bot:push-dev-services --scp --restart` and `botctl dev-push enter`
 *   wrote `dev_push_state.json`.
 * - `registry-local-dev`: the active build was created by
 *   `sb bot:push-dev-services` (registry path) — its release branch starts
 *   with `/local-dev/`, surfaced via `active_build.json.name`.
 * - `null`: this CB is running a normal build; no banner should render.
 */
export const DevPushStateData = zod.discriminatedUnion('source', [
  zod.object({ source: zod.literal('scp'), services: zod.array(zod.string()) }),
  zod.object({
    source: zod.literal('registry-local-dev'),
    buildName: zod.string(),
  }),
  zod.object({ source: zod.null() }),
]);

export type DevPushStateData = zod.infer<typeof DevPushStateData>;
